export default "__VITE_ASSET__E995Mlx2__"